import React, { Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import Layout from "Layout";
import NonAuthLayout from "Layout/NonAuthLayout";
import { publicRoutes, authProtectedRoutes } from "./allRoutes";
import { AuthProtected } from "./AuthProtected";

const Index = () => {

  return (
    <Suspense>
      <Routes>
        <Route>
          {publicRoutes.map((route: any, idx: number) => (
            <Route
              key={idx}
              path={route.path}
              element={<NonAuthLayout> {route.component} </NonAuthLayout>}
            />
          ))}
        </Route>
        <Route>
          {authProtectedRoutes.map((route: any, idx: number) => (
            <Route
              key={idx}
              path={route.path}
              element={
                route.element ? (
                  route.element
                ) : (
                  <AuthProtected>
                    <Layout>{route.component}</Layout>
                  </AuthProtected>
                )
              }
            />
          ))}
        </Route>
      </Routes>
    </Suspense>
  );
};

export default Index;
